import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Map } from '../../../common/components'
import ConfigureWithDefault from './ConfigureWithDefault'
import { LocationDropDown, MapMarker, MileSelect, Label } from './LocationComponents'
import { Theme } from '@pga/pga-component-library'
import { pathOr } from 'ramda'
import { meterToMiles, milesToKMRnd } from '../../../common/functions/converters'
import FaAngleDown from 'react-icons/lib/fa/angle-down'
import { connectConfig } from '../../config'
import { DEFAULT_RADIUS } from '../../utils'

const AngleDown = styled(FaAngleDown)`
  display: none;
  color: ${Theme.colors.primary};
  @media screen and (max-width: 991.98px) {
    display: block;
  }
  @media screen and (max-width: 575px) {
    margin-top: 5px;
  }
`
export class RadiusFilter extends React.Component {
  constructor (props) {
    super(props)
    this.handleRadiusChange = this.handleRadiusChange.bind(this)
  }

  handleRadiusChange ({ target: { value } }) {
    const { onSearchStateChange } = this.props
    const aroundRadius = milesToKMRnd(value)
    const options = { configure: { aroundRadius } }
    onSearchStateChange(options)
  }

  render () {
    const { proximityOptions, searchState, config } = this.props
    const { aroundRadius = DEFAULT_RADIUS } = pathOr({}, ['configure'], searchState)
    return (
      <Fragment>
        <ConfigureWithDefault {...config} />
        <LocationDropDown>
          <Label htmlFor='location-proximity-miles'>
            <MapMarker size={18} /> <AngleDown /> Within
          </Label>
          <MileSelect onChange={this.handleRadiusChange} className='form-control' id='location-proximity-miles' value={meterToMiles(aroundRadius) || 25}>
            <Map mappable={proximityOptions}>
              {({ text, value }) => <option value={value} key={value}>{text}</option>}
            </Map>
          </MileSelect>
        </LocationDropDown>
      </Fragment>
    )
  }
}

RadiusFilter.propTypes = {
  searchState: PropTypes.object.isRequired,
  onSearchStateChange: PropTypes.func.isRequired,
  proximityOptions: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired
    })
  ).isRequired
}

export default connectConfig(RadiusFilter)
